import React from "react";
import { ICON_PEN } from "../utils/icons";
import { Button } from "../styles";

function SettingsWrapper({ children, title, onEdit }) {

      return (
            <>
                  <div className="light-bg py-4 px-3 br-sm mt-4 min-height-lg">
                        <div className="d-flex flex-wrap gap-2 justify-content-between">
                              <h6 className="fw-bold pry-text" > {title} </h6>
                              {onEdit &&
                                    <div className="mb-4">
                                          <Button pry className="btn shadow-none" onClick={onEdit}>
                                                {ICON_PEN} EDIT
                                          </Button>
                                    </div>
                              }
                        </div>

                        <div className="container">
                              {children}
                        </div>
                  </div>
            </>
      );
}

export default SettingsWrapper;
